import { Store } from '../../types';

import { overviewValidator } from './overviewValidator';

export const thankYouValidator = (state: Store): boolean => {
	if (!overviewValidator(state)) return false;
	if (!state.agreedToTerms) return false;
	return true;
};
